import config from '../config'
import axios from 'axios'

const initialState = {
  auth: {},
  authenticationTimeout: 100,
  intervalId: undefined
}

const getters = {
  auth: state => state.auth,
  currentUserId: state => state.auth.id,
  authenticationTimeout: state => state.authenticationTimeout
}

const mutations = {
  auth(state, authData) {
    state.auth = authData
  },
  authenticationTimeout(state, authenticationTimeout) {
    state.authenticationTimeout = authenticationTimeout
  },
  intervalId(state, intervalId) {
    state.intervalId = intervalId
  }
}

const actions = {
  async apiStatus() {
    const result = await axios.get(`${config.getRootApi()}/health`).catch(function () {
      return false
    })
    return result.status === 200
  },
  // for OPENID
  async authenticateByCode({ commit, state, dispatch }, code) {
    return axios.post(`${config.getRootApi()}/auth/check-authent?code=${code}`, { token: state.token })
      .then(() => true)
      .catch(() => false)
  },
  // for SAML
  async authenticate({ commit, dispatch }) {
    let res = null
    try {
      res = await axios.get(`${config.getRootApi()}/auth`)
    } catch (e) {
      console.log(e)
      return false
    }
    const authData = res.data
    if (authData) {
      commit('auth', authData)
      // need await so router.beforeEach can use current user value
      await dispatch('fetchUserCommunities')
      await dispatch('fetchCurrentUser', authData.id)
      await dispatch('initUser')
      return true
    }
    return false
  },
  initUser({ dispatch, commit, state }) {
    dispatch('resetPosts')
    dispatch('fetchCommunities')
    dispatch('fetchUserCommunities')
    dispatch('fetchUserStats')
    dispatch('resetUserJoinRequests')
    dispatch('resetSuggestedCommunities')
    checkNewNotifications(dispatch, state)
    let intervalId = window.setInterval(checkNewNotifications, 60000, dispatch, state)
    commit('intervalId', intervalId)
  },

  async redirectToAuthWorkflow({ commit }) {
    commit('auth', { id: null })
    window.location = await axios.get(`${config.getRootApi()}/auth/auth-redirect-url`)
      .then(data => data.data.url)
  }
}

function checkNewNotifications(dispatch, state) {
  dispatch('countNewNotifications')
    .catch(error => {
      if (error.response.status === 401 && state.intervalId) {
        window.clearInterval(state.intervalId)
      }
    })
}

export default {
  state: initialState,
  getters,
  mutations,
  actions
}
